import React, { useState, useCallback, useMemo, useContext, useEffect } from "react";
import FieldInputText from "components/FieldInputText";
import FieldInputSelect from "components/FieldInputSelect";
import { Projections } from "constants/common";
import * as Yup from "yup";
import BaseForm from "./BaseForm";
import {FormContext} from "./index";

const FormProjection = () => {
    const [projectionAttributes, setProjectionAttributes] = useState<any[]>([]);
    const schema = Yup.object().shape({
      projection: Yup.string().required().label("Projection")
    })

    const getProjectionAttributes = (value: any) => {
      const projection = Projections.find((elm: any) => elm.value === value);
      setProjectionAttributes(projection?.attributes || []);
    }
    const { defaultValues} = useContext<any>(FormContext);

    useEffect(() => {
      getProjectionAttributes(defaultValues['projection']);
    }, [defaultValues])

    const handleChange = useCallback((event: any) => {
        getProjectionAttributes(event.target.value)
    }, [Projections]);
  
    const ProjectionsData = useMemo(() => {
      const data = Projections.map((entry: any) => {
        const { text:label, value} = entry;
        return {
          label,
          value
        }
      });

      return data;
    }, [Projections]);
   
    return (
      <BaseForm
        schema={schema}
        render={(methods: any) => (
          <>
            <FieldInputSelect 
                name="projection" 
                options={ProjectionsData}
                control={methods.control} 
                label="Projection" 
                changeHandler={handleChange}
            />
            {projectionAttributes.map((attribute: any, idx: number) => {
                    const { name, text:label, value, values} = attribute;
                    let defaultValue = '';
                    const options = !!values ? values.map((entry: any, index: number) => {
                        const { text:label, value} = entry;
                        !index && (defaultValue = value);
                        return { label, value}
                    }) : [];

                return options.length> 0 ? (
                    <FieldInputSelect 
                        key={`projection-${name}-${idx}`}
                        name={name}
                        options={options}
                        control={methods.control} 
                        label={label}
                        //changeHandler={handleChange}
                    />
                ) : (
                    <FieldInputText 
                        key={`projection-${name}-${idx}`}
                        name={name}
                        type="number"
                        control={methods.control} 
                        label={label}
                    />
                )
            })}
          </>
        )}
      />
    );
  }
  
  export default FormProjection;